import { render, staticRenderFns } from "./ProdutosFornecedorConfigProduto.vue?vue&type=template&id=dd6cb6e8"
import script from "./ProdutosFornecedorConfigProduto.vue?vue&type=script&lang=js"
export * from "./ProdutosFornecedorConfigProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports